import React, { useEffect, useRef, useState } from "react";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import BetSlipContext from "../../context/BetSlipContext";
import { isMobile } from "react-device-detect";
const SportsHeader = ({ count, setSearch, setNotification, setSetting }) => {
  const setSportsTab = useContextSelector(AuthContext, (ctx) => {
    return ctx.setSportsTab;
  });
  const sportTab = useContextSelector(AuthContext, (ctx) => {
    return ctx.sportTab;
  });
  const setTab = useContextSelector(AuthContext, (ctx) => {
    return ctx.setTab;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const tab = useContextSelector(AuthContext, (ctx) => {
    return ctx.tab;
  });
  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });
  const parlay = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlay;
  });
  const setParlay = useContextSelector(AuthContext, (ctx) => {
    return ctx.setParlay;
  });

  const sportsTabs =
    tab == "leagues"
      ? [
          {
            key: "myfav",
            label: "My Fav",
            icon: "s-icon-star-solid",
            count: 0,
          },
          {
            key: "cricket",
            label: "Cricket",
            icon: "s-icon-cricket",
            count: count?.cricketInplayCount,
            isSelected: false,
          },
          {
            key: "soccer",
            label: "Soccer",
            icon: "s-icon-soccer",
            count: count?.soccerInplayCount,
            isSelected: false,
          },
          {
            key: "tennis",
            label: "Tennis",
            icon: "s-icon-tennis",
            count: count?.tennisInplayCount,
            isSelected: false,
          },
        ]
      : parlay
        ? [
            {
              key: "cricket",
              label: "Cricket",
              icon: "s-icon-cricket",
              count: count?.cricketInplayCount,
              isSelected: false,
            },
            {
              key: "soccer",
              label: "Soccer",
              icon: "s-icon-soccer",
              count: count?.soccerInplayCount,
              isSelected: false,
            },
            {
              key: "tennis",
              label: "Tennis",
              icon: "s-icon-tennis",
              count: count?.tennisInplayCount,
              isSelected: false,
            },
          ]
        : [
            {
              key: "myfav",
              label: "My Fav",
              icon: "s-icon-star-solid",
              count: 0,
            },
            {
              key: "all",
              label: "All",
              icon: "s-icon-all",
              count:
                count?.cricketInplayCount +
                count?.tennisInplayCount +
                count?.soccerInplayCount,
              isSelected: true,
            },
            {
              key: "cricket",
              label: "Cricket",
              icon: "s-icon-cricket",
              count: count?.cricketInplayCount,
              isSelected: false,
            },
            {
              key: "soccer",
              label: "Soccer",
              icon: "s-icon-soccer",
              count: count?.soccerInplayCount,
              isSelected: false,
            },
            {
              key: "tennis",
              label: "Tennis",
              icon: "s-icon-tennis",
              count: count?.tennisInplayCount,
              isSelected: false,
            },
          ];

  const tabs = parlay
    ? [
        {
          key: ["in_play"],
          label: "Live",
          active: true,
        },
        {
          key: ["today", "active"],
          label: "Upcoming",
          active: false,
        },
      ]
    : [
        {
          key: ["in_play"],
          label: "Live",
          active: true,
        },
        {
          key: ["today", "active"],
          label: "Upcoming",
          active: false,
        },
        {
          key: ["leagues"],
          label: "Leagues",
          active: false,
        },
      ];

  const navigate = useNavigate();
  const containerRef = useRef(null);
  const [indicatorStyle, setIndicatorStyle] = useState({ x: 0, width: 0 });
  const [activeIndex, setActiveIndex] = useState(1);
  // Function to update indicator position & width
  const updateIndicator = (index) => {
    if (!containerRef.current) return;

    const tab = containerRef.current.children[index];
    if (tab) {
      const rect = tab.getBoundingClientRect();
      const containerRect = containerRef.current.getBoundingClientRect();

      setIndicatorStyle({
        x: rect.left - containerRect.left, // X position inside container
        width: rect.width, // Tab width
      });
    }
  };
  // Handle tab click
  const handleClick = (index) => {
    setActiveIndex(index);
    updateIndicator(index);
  };
  // Update indicator on initial load and window resize
  useEffect(() => {
    updateIndicator(activeIndex);

    const handleResize = () => {
      updateIndicator(activeIndex);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [activeIndex]);

  return (
    <div
      data-v-ce6bad6d
      id="s-index-filter"
      className={
        isMobile
          ? "s-pt-7px s-sports-mode-filter s-bg-body s-z-10 s-sticky"
          : "s-pt-7px s-sports-mode-filter s-bg-body s-z-10 s-sticky s-top-0 s-z-30 s-bg-body"
      }
      style={{
        top: isMobile ? "13.33vw" : 0,
        "--5fb04646": `${indicatorStyle?.width || 58}px`,
        "--53331f6c": `translateX(${
          indicatorStyle?.x + (indicatorStyle?.width || 58)
        }px)`,
      }}
    >
      <div data-v-ce6bad6d className="s-flex s-ml-7px s-justify-between">
        <div
          data-v-ce6bad6d
          className="s-sports-mode-filter-types s-flex s-items-center s-text-center s-text-14px s-rounded-t-5px s-bg-main-tab-bg s-text-black dark:s-text-global-font-default-dark"
        >
          <div className="s-flex s-items-center s-h-full">
            {tabs.map((item) => (
              <div
                key={item.key}
                onClick={() => {
                  setTab(item.key[0]);
                  if (item?.key[0] == "leagues") {
                    setSportsTab("cricket");
                    handleClick(1);
                  } else {
                    if (parlay) {
                      handleClick(0);
                      setSportsTab("cricket");
                    } else {
                      handleClick(1);
                      setSportsTab("all");
                    }
                  }
                }}
                className={`s-relative s-h-full s-flex s-items-center s-justify-center s-rounded-t-5px s-px-11px s-z-20 ${
                  item?.key.includes(tab)
                    ? "s-bg-main-tab-bg-active s-text-main-tab-text-active"
                    : "s-text-main-tab-text"
                }`}
              >
                {/* Left SVG for active tab */}
                {item?.key.includes(tab) && (
                  <div className="s-absolute -s-left-4 s-bottom-0 s-w-14px s-h-14px">
                    <svg
                      width="8px"
                      height="8px"
                      viewBox="0 0 8 8"
                      xmlns="http://www.w3.org/2000/svg"
                      className="s-svg-image s-absolute s-right-0 s-bottom-0 s-w-7px s-h-7px"
                    >
                      <title>tab-radius-l</title>
                      <g
                        stroke="none"
                        strokeWidth={1}
                        fill="none"
                        fillRule="evenodd"
                        className="s-fill-main-tab-bg-active"
                      >
                        <path
                          d="M0,0 C0,4.418278 3.581722,8 8,8 L0,8 L0,0 Z"
                          transform="translate(4, 4) scale(-1, 1) translate(-4, -4)"
                        />
                      </g>
                    </svg>
                  </div>
                )}

                {/* Label */}
                <span>{item.label}</span>

                {/* Right SVG for active tab */}
                {item?.key.includes(tab) && (
                  <div className="s-absolute s--right-4 s-bottom-0 s-w-14px s-h-14px">
                    <svg
                      width="8px"
                      height="8px"
                      viewBox="0 0 8 8"
                      xmlns="http://www.w3.org/2000/svg"
                      className="s-svg-image s-absolute s-left-0 s-bottom-0 s-w-7px s-h-7px"
                    >
                      <title>tab-radius-r</title>
                      <g
                        stroke="none"
                        strokeWidth={1}
                        fill="none"
                        fillRule="evenodd"
                        className="s-fill-main-tab-bg-active"
                      >
                        <path d="M0,0 C0,4.418278 3.581722,8 8,8 L0,8 L0,0 Z" />
                      </g>
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div
            onClick={() => {
              setParlay(!parlay);
              if (parlay) {
                handleClick(1);
                setSportsTab("all");
              } else {
                handleClick(0);
                setSportsTab("cricket");
              }
              if (tab == "leagues") {
                setTab("in_play");
              }
            }}
            data-v-ce6bad6d
            className={`s-relative s-h-full s-flex s-items-center s-justify-around s-rounded-t-5px s-w-59px ${
              parlay
                ? "s-text-main-tab-parlay-text-active s-bg-main-tab-parlay s-z-10"
                : "s-text-main-tab-parlay-text s-px-11px"
            } `}
          >
            <div className="s-flex s-items-center">
              <span
                className="s-icon-check s-text-8px s-w-8px s-mr-3px"
                style={parlay ? {} : { display: "none" }}
              />
              <span>Parlay</span>
              <div
                data-v-16f79fce
                className="s-absolute s--right-4 s-bottom-0 s-w-14px s-h-14px"
              >
                <svg
                  data-v-16f79fce
                  width="8px"
                  height="8px"
                  viewBox="0 0 8 8"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  className="s-svg-image s-absolute s-left-0 s-bottom-0 s-w-7px s-h-7px"
                >
                  <title data-v-16f79fce>tab-radius-r</title>
                  <g
                    data-v-16f79fce
                    id="Page-1"
                    stroke="none"
                    strokeWidth={1}
                    fill="none"
                    fillRule="evenodd"
                    data-is-selected="false"
                    className="s-fill-main-tab-bg"
                  >
                    <path
                      data-v-16f79fce
                      d="M0,0 C0,4.418278 3.581722,8 8,8 L0,8 L0,0 Z"
                      id="tab-radius-r"
                    />
                  </g>
                </svg>
              </div>
              {/**/}
            </div>
          </div>
        </div>
        <div
          data-v-ce6bad6d
          className="s-flex s-text-12px s-space-x-2 s-pl-16px s-pr-7px s-mb-3px s-text-icon-dark dark:s-text-icon-light"
        >
          <div
            onClick={() => setSearch(true)}
            data-v-19be382e
            data-v-ce6bad6d
            className="s-flex s-justify-center s-items-center s-w-24px s-h-24px s-bg-filter-background-light dark:s-bg-filter-background-dark s-rounded-full s-shadow-2sm"
            style={{ "--c5e74cec": "none" }}
          >
            <span
              data-v-19be382e
              className="s-icon-search dark:s-text-global-font-default-dark"
            />
          </div>
          <div
            onClick={() => setNotification(true)}
            data-v-56a526dc
            data-v-ce6bad6d
            className="s-flex s-justify-center s-items-center s-w-24px s-h-24px s-bg-filter-background-light dark:s-bg-filter-background-dark s-rounded-full s-shadow-2sm"
            style={{ "--2c7b7fd6": "none" }}
          >
            <span
              data-v-56a526dc
              className="s-icon-notifications dark:s-text-global-font-default-dark"
            />
          </div>
          <div
            onClick={() => setSetting(true)}
            data-v-9190ed79
            data-v-ce6bad6d
            className="s-flex s-justify-center s-items-center s-w-24px s-h-24px s-bg-filter-background-light dark:s-bg-filter-background-dark s-rounded-full s-shadow-2sm"
            style={{ "--1003903d": "none" }}
          >
            <span
              data-v-9190ed79
              className="s-icon-setting dark:s-text-global-font-default-dark"
            />
          </div>
        </div>
      </div>
      <div
        ref={containerRef}
        data-v-ce6bad6d
        className="s-sports-eventType-tabs s-relative s-grid s-items-center s-text-center s-text-10px s-font-bold s-pl-3px s-pr-3px s-h-50px s-overflow-hidden s-bg-gradient-to-b s-from-header-from s-to-header-to"
        data-has-casino-tab="true"
        data-has-all-event-type-tab="true"
      >
        <div
          onClick={() => navigate("/casino?type=casino&provider=PT")}
          data-v-f34fa1c6
          data-v-ce6bad6d
          className="s-w-60.6px s-h-44px s-mr-3px"
          style={{
            "--1b11d2b0": 'url("/assets/IconBetting/chip.webp")',
            "--30af444b": "none",
          }}
        >
          <div
            data-v-f34fa1c6
            className="s-py-5px s-h-full s-flex s-flex-col s-items-center s-justify-between s-bg-light"
          >
            <div
              data-v-f34fa1c6
              className="s-bg-contain s-bg-no-repeat s-bg-center s-chip s-w-24px s-h-19px"
            />
            <p
              data-v-f34fa1c6
              className="s-text-12px s-text-secondary dark:s-text-global-font-default-dark s-content-light s-pt-3px"
            >
              {" "}
              Casino{" "}
            </p>
          </div>
        </div>

        {sportsTabs.map((res, index) => (
          <div
            key={index}
            data-v-ce6bad6d
            onClick={() => {
              if (res?.key == "myfav" && isEmpty(user)) {
                setToastObject({
                  type: "warning",
                  title: "Warning",
                  message: "Please login to place your bet!",
                  status: true,
                });
              } else {
                setSportsTab(res.key);
                handleClick(index);
              }
            }}
            className="s-relative s-z-10"
          >
            <div
              data-v-4901c359
              className="s-menu-active s-h-44px s-flex s-flex-col s-justify-center s-items-center s-py-5px s-rounded-5px s-z-20"
              data-is-selected={res.key === sportTab}
              data-is-my-pin-mode="false"
            >
              {/* ICON */}
              <span
                data-v-c1acd3d8
                data-v-4901c359
                className={`s-event-type-icon s-text-19px ${res.icon}`}
                data-is-selected={res.key === sportTab}
                data-is-my-pin-mode="false"
                data-has-casino-tab="true"
                data-has-all-event-type-tab="true"
              />

              {/* COUNT BADGE */}
              {tab !== "leagues" && res.key !== "myfav" && (
                <div
                  data-v-4901c359
                  data-is-selected={res.key === sportTab ? "true" : "false"}
                  data-is-my-pin-mode={false}
                  className="s-event-count s-flex s-items-center s-text-9 s-justify-center s-absolute s-top-0 s-left-39px s-px-2px s-min-w-14px s-h-14px s-rounded-full s-font-normal"
                >
                  <span data-v-4901c359 className="s-h-10px">
                    {res.count}
                  </span>
                </div>
              )}

              {/* LABEL */}
              <p
                data-v-64098ea2
                data-v-4901c359
                data-is-selected={res.key === sportTab}
                data-is-my-pin-mode="false"
                className="s-event-type-context s-text-12px s-pt-3px"
              >
                {res.label}
              </p>
            </div>
          </div>
        ))}

        <motion.div
          data-v-ce6bad6d
          className="tab-indicator s-absolute s-left-0 s-top-3px s-bg-main-menu-bg-active s-h-44px s-rounded-5px"
          layoutId="pill-tab-submenu" // 🔑 DIFFERENT ID
          transition={{ type: "spring", duration: 0.5 }}
        />

        {/* <div
          data-v-ce6bad6d
          className="tab-indicator s-absolute s-left-0 s-top-3px s-bg-main-menu-bg-active s-h-44px s-rounded-5px"
        /> */}
      </div>
    </div>
  );
};

export default SportsHeader;
